export function getSortNameReadableFormat(option: string | undefined) {
  switch (option) {
    case 'popular':
      return 'Popularity';
    case 'low_to_high':
      return 'Price: Low to high';
    case 'high_to_low':
      return 'Price: High to low';
    case 'earliest_available':
      return 'Earliest available';
    case 'recently_added':
      return 'Recently added';
    default:
      return undefined;
  }
}
